import { formatWeightValueForDisplay } from '@src/common/components/FormatWeightValueForDisplay';
import type { TFunction } from 'i18next';

export const toDisplayWeightValue = ({
  value,
  showInMetric,
  t,
}: {
  value: string;
  showInMetric: boolean;
  t: TFunction;
}) => {
  const formattedValue = formatWeightValueForDisplay(value, showInMetric);

  if (showInMetric) return { value: +formattedValue, unit: t('units.kilos') };
  return { value: +formattedValue, unit: t('units.pounds') };
};
